// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/logoBabitaW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/menuBtnW.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../imgs/bagW.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --color-hex: #FFFFFF;
    --qtde: 0;
}

.topMenu{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top:0;
    background-color: var(--escuroAzulMid1);
    width: 100%;
    height: 7vh;
    padding: 1vh 0; 
    z-index: 10000  !important;
}

.topMenu.mostraMenuoverlay {
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    background: rgba(39, 49, 55, 0.4);
    /* transition: all 1s ease-in-out; */
  }

.topMenu .leftMenu{
    display: flex;
    width: 50%;
}



.topMenu .logo{
    aspect-ratio: 25 / 8;
    width: fit-content;
    /* background-color: #000; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: 2%;
    margin-left: 2vw;
    margin: 0 0 0 50px;
    height: 5vh;
    align-self: left;
    /* aspect-ratio: 350 / 111; */
}

.topMenu .clientInfo{
    font-family: 'Cardo-Bold';
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.topMenu .email{
    font-family: 'Cardo-Bold';
    color: #575656;
}

/* .topMenu .buttonEdit, .lateralMenu .buttonEdit{
    width: fit-content;
    padding: 2%;
    margin-top: 3%;
    border-radius: 5px;
    cursor: pointer;
    -webkit-box-shadow: 0px 4px 4px 0px #00000040;
    -moz-box-shadow: 0px 4px 4px 0px #00000040;
    box-shadow: 0px 4px 4px 0px #00000040;
} */


.topMenu .sideMenuBtn{
    margin: auto 0;
    margin-right: 2vw;
    height: 40px;
    aspect-ratio: 1/1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
}


.topMenu .sacola{
    display: flex;
    position: relative;
    margin: auto 0 auto auto;
    margin-right: 40px;
    height: 40px;
    aspect-ratio: 1/1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.topMenu .sacola::after {
    content: var(--qtde);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--whiteNw-pastel-color);
    color: var(--escuroAzulMid1);
    transform: translate(-40%, -40%);
    line-height: 0;
    font-family: "Montserrat", sans-serif;
    font-size: 0.9em;
    font-weight: 500;
}



/* MENU LATERAL */

.lateralMenu{
    position: fixed;
    top: 0;
    left: 0;
    width: 22%;
    height: 100vh;
    padding: 0% 2%;
    background-color: var(--whiteNw-pastel-color);
    z-index: 9999999 !important;
    color: var(--escuroAzulMid1r);
    text-align: center;
    transition: all 1s ease-in-out;
}


.decorateMenuLinha{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
    z-index: 10;
    border-radius: 5px;
    overflow: hidden;
    left: 0;
    top: 0;
}

.decorateMenuLinha div{
    background: #706a6a;
    background: linear-gradient(180deg, #706a6a 0%, 
        var(--white-color) 16%, var(--white-color) 80%, #706a6a 100%);
    position: absolute;
}

.decorateMenuLinha .linhaLeft{
    top: 1%;
    left: 1%;
    width: 3px;
    height: 98%;
}

.decorateMenuLinha .linhaRigh{
    top: 1%;
    right: 1%;
    width: 3px;
    height: 98%;
}

.decorateMenuLinha .linhaTop{
    top: 1%;
    right: 1%;
    width: 98%;
    height: 3px;
    background: #706a6a;
}

.decorateMenuLinha .linhaBottom{
    bottom: 1%;
    right: 1%;
    width: 98%;
    height: 3px;
    background: #706a6a;
}

.lateralMenu .logo{
    width: 30%;
    aspect-ratio: 1.20/1;
    background-size: contain;
    background-color: var(--escuroAzulMid1);
    /* background-image: url('../imgs/menuLogoW.png'); */
    background-repeat: no-repeat;
    margin: 5% auto;
}


.lateralMenu .clientInfo{
    position: relative;
    z-index: 30;
    font-family: 'Cardo-Bold';
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.lateralMenu .email{
    font-family: 'Cardo-Bold';
    color: #C2C2C2;
}

/* .lateralMenu .buttonEdit{
    background-color: var(--white-color);
    color: #000000;
} */

.lateralMenulineBar{
    height: 2px;
    width: 85%;
    margin: 4% auto 2% auto;
    background-color: #888888;
}


.lateralMenuRedirect{
    width: 100%;
    margin-top: 5%;
    font-size: 2em;
    text-align: start;
    max-height: 62vh;
    overflow-y: auto;
}


/* BUTTONS */

.lateralMenuRedirect > div{
    margin: 3% 0;
    cursor: pointer;
    text-align: center;
    padding: 5px 0;
    border: 2px solid var(--escuroAzulMid1);
    border-radius: 5px;
    color: var(--escuroAzulMid1);
}

.lateralMenuRedirect > div.activeMenu{
    color: var(--whiteNw-pastel-color);
    background-color: var(--escuroAzulMid1);
}

.lateralMenuRedirect .subMenuDrop > div{
    margin: 8px auto; 
}

.lateralMenuRedirect .divisorDrop{
    width: 80%;
    height: 2px;
    margin: 6px auto;
    background-color: var(--white-color);
}

.lateralMenuRedirect .divisorDrop.activeMenu{
    background-color: var(--escuro-azul2-color);
}

.lateralMenuRedirect .subMenuDrop .subBtns.activeMenu{
    color: #076aff;
}


/* SCROOL BUTTONS */

.lateralMenuRedirect::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #f5f5f5;
}

.lateralMenuRedirect::-webkit-scrollbar
{
	width: 5px;
	background-color: #2c2727d7;
}

.lateralMenuRedirect::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #5d5d5d;
}




.lateralMenuSair{
    position: fixed;
    bottom: 2%;
    font-size: 2em;
    cursor: pointer;
}


.lateralMenu .menuCloseBtn{
    display: flex;
    position: absolute;
    z-index: 30;
    right: 3%;
    top: 4%;
    width: 50px;
    height: 5px;
    border-radius: 15px;
    background-color: var(--escuroAzulMid1);
    rotate : -47deg;
    cursor: pointer;
}

.lateralMenu .menuCloseBtn::before{
    content: '';
    width: 50px;
    height: 5px;
    border-radius: 15px;
    background-color: var(--escuroAzulMid1);
    rotate : -89deg;
    filter: drop-shadow(0px 1px 1px #00000088);
}

.overlaytopMenu {
    position: fixed;
    inset: 0;
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
    background: rgba(39, 49, 55, 0);
    z-index: 0;
    display: none;
  }

  .overlaytopMenu.mostraMenuoverlay {
    display: block;
    position: fixed;
    inset: 0;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    background: rgba(39, 49, 55, 0.4);
    z-index: 1000;
    transition: all 1s ease-in-out;
  }

.lateralMenuInicial{
    opacity: 0;
    width: 0;
    padding: 0;
    display: none;
}

.lateralMenu.mostraMenuLateral{
    animation: 1s showMenu forwards 0s ease-in-out;
}

.lateralMenu.escondeMenuLateral{
    animation: 1s hideMenu forwards 0s ease-in-out;
}

@media(max-width: 1400px){
    .topMenu .clientInfo .nome{
        font-size: 0.9em;
    }
    .topMenu .clientInfo .email{
        font-size: 0.9em;
    }

    .lateralMenuRedirect {
        font-size: 1.6em;
    }

    .lateralMenu .clientInfo{
        font-size: 0.9em;
    }

    .lateralMenu .menuCloseBtn {
        width: 35px;
        height: 4px;
    }

    .lateralMenu .menuCloseBtn::before {
        width: 35px;
        height: 4px;
    }
}


@media(max-width: 767px){

    /* TOP MENU */

    .topMenu{
        height: 8vh;
    }

    .topMenu .logo{
        /* height: 54%;
        aspect-ratio: 1/1; */
        margin: auto 0;
        margin-left: 2vw;
        margin-right: 2%;
        /* background-image: url('../imgs/topLogoRound.svg'); */
        background-size: contain;
    }

    .topMenu .clientInfo{
        flex-direction: row;
        justify-content: center;
        align-items: center;
        max-width: 70vw;
        min-width: 70vw;
    }

    .topMenu .nome{
        font-size: 1em;
        flex: 2 1;
    }

    .bemVind{
        font-family: 'Cardo-Regular';
        flex: 2 1;
        max-width: max-content;
    }


    /* MENU LATERAL */
    .lateralMenu{
        width: 100%;
        height: 100%;
        height: 100vh;
        padding: 0;
        /* padding-left: 5%; */
    }

    .lateralMenu .menuCloseBtn{
        right: 4%;
        top: 4%
    }

    .lateralMenu.mostraMenuLateral{
        animation: 1s showMenuMobile forwards 0s ease-in-out;
    }

    .lateralMenu.escondeMenuLateral{
        animation: 1s hideMenuMobile forwards 0s ease-in-out;
    }

    .lateralMenuRedirect {
        width: 80%;
    }

}


@keyframes showMenu {
    0%{
        width: 0;
        padding: 0;
        opacity: 0;
        /* opacity: 1; */
    }
    20%{
        padding: 0% 2%;
    }
    70%{
        width: 22%;
    }
    100%{
        opacity: 1;
    }
}

@keyframes showMenuMobile {
    0%{
        width: 0;
        padding: 0;
        /* opacity: 0; */
        /* opacity: 1; */
    }
    20%{
    }
    70%{
        width: 100%;
    }
    100%{
        opacity: 1;
        /* padding-left: 5%; */
    }
}


@keyframes hideMenu {
    0%{
        width: 22%;
        padding: 0% 2%;
        opacity: 1;
    }
    20%{
    }
    100%{
        opacity: 0;
        width: 0;
        padding: 0;
        display: none;
    }
}


@keyframes hideMenuMobile {
    0%{
        width: 100%;
        /* padding-left: 5%; */
        opacity: 1;
    }
    20%{
        
    }
    100%{
        opacity: 0;
        width: 0;
        padding: 0;
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/topMenu.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,KAAK;IACL,uCAAuC;IACvC,WAAW;IACX,WAAW;IACX,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;IACjC,oCAAoC;EACtC;;AAEF;IACI,aAAa;IACb,UAAU;AACd;;;;AAIA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B,yDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;;;;;;GASG;;;AAGH;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,yDAA6C;IAC7C,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,yDAAyC;IACzC,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,4BAA4B;IAC5B,gCAAgC;IAChC,cAAc;IACd,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;AACpB;;;;AAIA,iBAAiB;;AAEjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,UAAU;IACV,aAAa;IACb,cAAc;IACd,6CAA6C;IAC7C,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,8BAA8B;AAClC;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,mBAAmB;IACnB;qEACiE;IACjE,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,QAAQ;IACR,UAAU;IACV,WAAW;AACf;;AAEA;IACI,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,wBAAwB;IACxB,uCAAuC;IACvC,oDAAoD;IACpD,4BAA4B;IAC5B,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;GAGG;;AAEH;IACI,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,yBAAyB;AAC7B;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA,YAAY;;AAEZ;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;;AAGA,mBAAmB;;AAEnB;;CAEC,iDAAiD;CACjD,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;;CAEC,UAAU;CACV,2BAA2B;AAC5B;;AAEA;;CAEC,mBAAmB;CACnB,gDAAgD;CAChD,yBAAyB;AAC1B;;;;;AAKA;IACI,eAAe;IACf,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,0BAA0B;IAC1B,kCAAkC;IAClC,+BAA+B;IAC/B,UAAU;IACV,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,0BAA0B;IAC1B,kCAAkC;IAClC,iCAAiC;IACjC,aAAa;IACb,8BAA8B;EAChC;;AAEF;IACI,UAAU;IACV,QAAQ;IACR,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;QACX,WAAW;IACf;AACJ;;;AAGA;;IAEI,aAAa;;IAEb;QACI,WAAW;IACf;;IAEA;QACI;4BACoB;QACpB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,uDAAuD;QACvD,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,SAAO;IACX;;IAEA;QACI,4BAA4B;QAC5B,SAAS;QACT,sBAAsB;IAC1B;;;IAGA,iBAAiB;IACjB;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,oDAAoD;IACxD;;IAEA;QACI,UAAU;IACd;;AAEJ;;;AAGA;IACI;QACI,QAAQ;QACR,UAAU;QACV,UAAU;QACV,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;IACA;IACA;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;QACV,sBAAsB;IAC1B;AACJ;;;AAGA;IACI;QACI,UAAU;QACV,cAAc;QACd,UAAU;IACd;IACA;IACA;IACA;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,WAAW;QACX,sBAAsB;QACtB,UAAU;IACd;IACA;;IAEA;IACA;QACI,UAAU;QACV,QAAQ;QACR,UAAU;QACV,aAAa;IACjB;AACJ","sourcesContent":[":root{\r\n    --color-hex: #FFFFFF;\r\n    --qtde: 0;\r\n}\r\n\r\n.topMenu{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    position: fixed;\r\n    top:0;\r\n    background-color: var(--escuroAzulMid1);\r\n    width: 100%;\r\n    height: 7vh;\r\n    padding: 1vh 0; \r\n    z-index: 10000  !important;\r\n}\r\n\r\n.topMenu.mostraMenuoverlay {\r\n    backdrop-filter: blur(2px);\r\n    -webkit-backdrop-filter: blur(2px);\r\n    background: rgba(39, 49, 55, 0.4);\r\n    /* transition: all 1s ease-in-out; */\r\n  }\r\n\r\n.topMenu .leftMenu{\r\n    display: flex;\r\n    width: 50%;\r\n}\r\n\r\n\r\n\r\n.topMenu .logo{\r\n    aspect-ratio: 25 / 8;\r\n    width: fit-content;\r\n    /* background-color: #000; */\r\n    background-image: url('../imgs/logoBabitaW.png');\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    margin-right: 2%;\r\n    margin-left: 2vw;\r\n    margin: 0 0 0 50px;\r\n    height: 5vh;\r\n    align-self: left;\r\n    /* aspect-ratio: 350 / 111; */\r\n}\r\n\r\n.topMenu .clientInfo{\r\n    font-family: 'Cardo-Bold';\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.topMenu .email{\r\n    font-family: 'Cardo-Bold';\r\n    color: #575656;\r\n}\r\n\r\n/* .topMenu .buttonEdit, .lateralMenu .buttonEdit{\r\n    width: fit-content;\r\n    padding: 2%;\r\n    margin-top: 3%;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    -webkit-box-shadow: 0px 4px 4px 0px #00000040;\r\n    -moz-box-shadow: 0px 4px 4px 0px #00000040;\r\n    box-shadow: 0px 4px 4px 0px #00000040;\r\n} */\r\n\r\n\r\n.topMenu .sideMenuBtn{\r\n    margin: auto 0;\r\n    margin-right: 2vw;\r\n    height: 40px;\r\n    aspect-ratio: 1/1;\r\n    background-image: url('../imgs/menuBtnW.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.topMenu .sacola{\r\n    display: flex;\r\n    position: relative;\r\n    margin: auto 0 auto auto;\r\n    margin-right: 40px;\r\n    height: 40px;\r\n    aspect-ratio: 1/1;\r\n    background-image: url('../imgs/bagW.png');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    cursor: pointer;\r\n    user-select: none;\r\n}\r\n\r\n.topMenu .sacola::after {\r\n    content: var(--qtde);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 50%;\r\n    background-color: var(--whiteNw-pastel-color);\r\n    color: var(--escuroAzulMid1);\r\n    transform: translate(-40%, -40%);\r\n    line-height: 0;\r\n    font-family: \"Montserrat\", sans-serif;\r\n    font-size: 0.9em;\r\n    font-weight: 500;\r\n}\r\n\r\n\r\n\r\n/* MENU LATERAL */\r\n\r\n.lateralMenu{\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 22%;\r\n    height: 100vh;\r\n    padding: 0% 2%;\r\n    background-color: var(--whiteNw-pastel-color);\r\n    z-index: 9999999 !important;\r\n    color: var(--escuroAzulMid1r);\r\n    text-align: center;\r\n    transition: all 1s ease-in-out;\r\n}\r\n\r\n\r\n.decorateMenuLinha{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: transparent;\r\n    z-index: 10;\r\n    border-radius: 5px;\r\n    overflow: hidden;\r\n    left: 0;\r\n    top: 0;\r\n}\r\n\r\n.decorateMenuLinha div{\r\n    background: #706a6a;\r\n    background: linear-gradient(180deg, #706a6a 0%, \r\n        var(--white-color) 16%, var(--white-color) 80%, #706a6a 100%);\r\n    position: absolute;\r\n}\r\n\r\n.decorateMenuLinha .linhaLeft{\r\n    top: 1%;\r\n    left: 1%;\r\n    width: 3px;\r\n    height: 98%;\r\n}\r\n\r\n.decorateMenuLinha .linhaRigh{\r\n    top: 1%;\r\n    right: 1%;\r\n    width: 3px;\r\n    height: 98%;\r\n}\r\n\r\n.decorateMenuLinha .linhaTop{\r\n    top: 1%;\r\n    right: 1%;\r\n    width: 98%;\r\n    height: 3px;\r\n    background: #706a6a;\r\n}\r\n\r\n.decorateMenuLinha .linhaBottom{\r\n    bottom: 1%;\r\n    right: 1%;\r\n    width: 98%;\r\n    height: 3px;\r\n    background: #706a6a;\r\n}\r\n\r\n.lateralMenu .logo{\r\n    width: 30%;\r\n    aspect-ratio: 1.20/1;\r\n    background-size: contain;\r\n    background-color: var(--escuroAzulMid1);\r\n    /* background-image: url('../imgs/menuLogoW.png'); */\r\n    background-repeat: no-repeat;\r\n    margin: 5% auto;\r\n}\r\n\r\n\r\n.lateralMenu .clientInfo{\r\n    position: relative;\r\n    z-index: 30;\r\n    font-family: 'Cardo-Bold';\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.lateralMenu .email{\r\n    font-family: 'Cardo-Bold';\r\n    color: #C2C2C2;\r\n}\r\n\r\n/* .lateralMenu .buttonEdit{\r\n    background-color: var(--white-color);\r\n    color: #000000;\r\n} */\r\n\r\n.lateralMenulineBar{\r\n    height: 2px;\r\n    width: 85%;\r\n    margin: 4% auto 2% auto;\r\n    background-color: #888888;\r\n}\r\n\r\n\r\n.lateralMenuRedirect{\r\n    width: 100%;\r\n    margin-top: 5%;\r\n    font-size: 2em;\r\n    text-align: start;\r\n    max-height: 62vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n\r\n/* BUTTONS */\r\n\r\n.lateralMenuRedirect > div{\r\n    margin: 3% 0;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    padding: 5px 0;\r\n    border: 2px solid var(--escuroAzulMid1);\r\n    border-radius: 5px;\r\n    color: var(--escuroAzulMid1);\r\n}\r\n\r\n.lateralMenuRedirect > div.activeMenu{\r\n    color: var(--whiteNw-pastel-color);\r\n    background-color: var(--escuroAzulMid1);\r\n}\r\n\r\n.lateralMenuRedirect .subMenuDrop > div{\r\n    margin: 8px auto; \r\n}\r\n\r\n.lateralMenuRedirect .divisorDrop{\r\n    width: 80%;\r\n    height: 2px;\r\n    margin: 6px auto;\r\n    background-color: var(--white-color);\r\n}\r\n\r\n.lateralMenuRedirect .divisorDrop.activeMenu{\r\n    background-color: var(--escuro-azul2-color);\r\n}\r\n\r\n.lateralMenuRedirect .subMenuDrop .subBtns.activeMenu{\r\n    color: #076aff;\r\n}\r\n\r\n\r\n/* SCROOL BUTTONS */\r\n\r\n.lateralMenuRedirect::-webkit-scrollbar-track\r\n{\r\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\r\n\tborder-radius: 10px;\r\n\tbackground-color: #f5f5f5;\r\n}\r\n\r\n.lateralMenuRedirect::-webkit-scrollbar\r\n{\r\n\twidth: 5px;\r\n\tbackground-color: #2c2727d7;\r\n}\r\n\r\n.lateralMenuRedirect::-webkit-scrollbar-thumb\r\n{\r\n\tborder-radius: 10px;\r\n\t-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);\r\n\tbackground-color: #5d5d5d;\r\n}\r\n\r\n\r\n\r\n\r\n.lateralMenuSair{\r\n    position: fixed;\r\n    bottom: 2%;\r\n    font-size: 2em;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.lateralMenu .menuCloseBtn{\r\n    display: flex;\r\n    position: absolute;\r\n    z-index: 30;\r\n    right: 3%;\r\n    top: 4%;\r\n    width: 50px;\r\n    height: 5px;\r\n    border-radius: 15px;\r\n    background-color: var(--escuroAzulMid1);\r\n    rotate : -47deg;\r\n    cursor: pointer;\r\n}\r\n\r\n.lateralMenu .menuCloseBtn::before{\r\n    content: '';\r\n    width: 50px;\r\n    height: 5px;\r\n    border-radius: 15px;\r\n    background-color: var(--escuroAzulMid1);\r\n    rotate : -89deg;\r\n    filter: drop-shadow(0px 1px 1px #00000088);\r\n}\r\n\r\n.overlaytopMenu {\r\n    position: fixed;\r\n    inset: 0;\r\n    backdrop-filter: blur(0px);\r\n    -webkit-backdrop-filter: blur(0px);\r\n    background: rgba(39, 49, 55, 0);\r\n    z-index: 0;\r\n    display: none;\r\n  }\r\n\r\n  .overlaytopMenu.mostraMenuoverlay {\r\n    display: block;\r\n    position: fixed;\r\n    inset: 0;\r\n    backdrop-filter: blur(2px);\r\n    -webkit-backdrop-filter: blur(2px);\r\n    background: rgba(39, 49, 55, 0.4);\r\n    z-index: 1000;\r\n    transition: all 1s ease-in-out;\r\n  }\r\n\r\n.lateralMenuInicial{\r\n    opacity: 0;\r\n    width: 0;\r\n    padding: 0;\r\n    display: none;\r\n}\r\n\r\n.lateralMenu.mostraMenuLateral{\r\n    animation: 1s showMenu forwards 0s ease-in-out;\r\n}\r\n\r\n.lateralMenu.escondeMenuLateral{\r\n    animation: 1s hideMenu forwards 0s ease-in-out;\r\n}\r\n\r\n@media(max-width: 1400px){\r\n    .topMenu .clientInfo .nome{\r\n        font-size: 0.9em;\r\n    }\r\n    .topMenu .clientInfo .email{\r\n        font-size: 0.9em;\r\n    }\r\n\r\n    .lateralMenuRedirect {\r\n        font-size: 1.6em;\r\n    }\r\n\r\n    .lateralMenu .clientInfo{\r\n        font-size: 0.9em;\r\n    }\r\n\r\n    .lateralMenu .menuCloseBtn {\r\n        width: 35px;\r\n        height: 4px;\r\n    }\r\n\r\n    .lateralMenu .menuCloseBtn::before {\r\n        width: 35px;\r\n        height: 4px;\r\n    }\r\n}\r\n\r\n\r\n@media(max-width: 767px){\r\n\r\n    /* TOP MENU */\r\n\r\n    .topMenu{\r\n        height: 8vh;\r\n    }\r\n\r\n    .topMenu .logo{\r\n        /* height: 54%;\r\n        aspect-ratio: 1/1; */\r\n        margin: auto 0;\r\n        margin-left: 2vw;\r\n        margin-right: 2%;\r\n        /* background-image: url('../imgs/topLogoRound.svg'); */\r\n        background-size: contain;\r\n    }\r\n\r\n    .topMenu .clientInfo{\r\n        flex-direction: row;\r\n        justify-content: center;\r\n        align-items: center;\r\n        max-width: 70vw;\r\n        min-width: 70vw;\r\n    }\r\n\r\n    .topMenu .nome{\r\n        font-size: 1em;\r\n        flex: 2;\r\n    }\r\n\r\n    .bemVind{\r\n        font-family: 'Cardo-Regular';\r\n        flex: 2 1;\r\n        max-width: max-content;\r\n    }\r\n\r\n\r\n    /* MENU LATERAL */\r\n    .lateralMenu{\r\n        width: 100%;\r\n        height: 100%;\r\n        height: 100vh;\r\n        padding: 0;\r\n        /* padding-left: 5%; */\r\n    }\r\n\r\n    .lateralMenu .menuCloseBtn{\r\n        right: 4%;\r\n        top: 4%\r\n    }\r\n\r\n    .lateralMenu.mostraMenuLateral{\r\n        animation: 1s showMenuMobile forwards 0s ease-in-out;\r\n    }\r\n\r\n    .lateralMenu.escondeMenuLateral{\r\n        animation: 1s hideMenuMobile forwards 0s ease-in-out;\r\n    }\r\n\r\n    .lateralMenuRedirect {\r\n        width: 80%;\r\n    }\r\n\r\n}\r\n\r\n\r\n@keyframes showMenu {\r\n    0%{\r\n        width: 0;\r\n        padding: 0;\r\n        opacity: 0;\r\n        /* opacity: 1; */\r\n    }\r\n    20%{\r\n        padding: 0% 2%;\r\n    }\r\n    70%{\r\n        width: 22%;\r\n    }\r\n    100%{\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n@keyframes showMenuMobile {\r\n    0%{\r\n        width: 0;\r\n        padding: 0;\r\n        /* opacity: 0; */\r\n        /* opacity: 1; */\r\n    }\r\n    20%{\r\n    }\r\n    70%{\r\n        width: 100%;\r\n    }\r\n    100%{\r\n        opacity: 1;\r\n        /* padding-left: 5%; */\r\n    }\r\n}\r\n\r\n\r\n@keyframes hideMenu {\r\n    0%{\r\n        width: 22%;\r\n        padding: 0% 2%;\r\n        opacity: 1;\r\n    }\r\n    20%{\r\n    }\r\n    100%{\r\n        opacity: 0;\r\n        width: 0;\r\n        padding: 0;\r\n        display: none;\r\n    }\r\n}\r\n\r\n\r\n@keyframes hideMenuMobile {\r\n    0%{\r\n        width: 100%;\r\n        /* padding-left: 5%; */\r\n        opacity: 1;\r\n    }\r\n    20%{\r\n        \r\n    }\r\n    100%{\r\n        opacity: 0;\r\n        width: 0;\r\n        padding: 0;\r\n        display: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
